import React, { useEffect, useState } from "react";
import { Box, Drawer, FormControl, Grid, TextField } from "@mui/material";

import ApiEndpoints from "../network/ApiEndPoints";
import { postJsonData } from "../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import Loader from "../component/loading-screen/Loader";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";

const EditUserCharge = ({ open, handleClose, data, onSuccess }) => {
  const [request, setRequest] = useState(false);
  const [payouts, setPayouts] = useState({
    payout1: "",
    payout2: "",
    payout3: "",
    payout4: "",
    payout5: "",
    min_amt: "",
    max_amt: "",
  });

  // 🔹 Prefill payouts when `data` changes
  useEffect(() => {
    if (data) {
      setPayouts({
        payout1: data.payout1 || "",
        payout2: data.payout2 || "",
        payout3: data.payout3 || "",
        payout4: data.payout4 || "",
        payout5: data.payout5 || "",
        min_amt: data.min_amt || "",
        max_amt: data.max_amt || "",
      });
    }
  }, [data]);

  // 🔹 Handle payout change
  const handlePayoutChange = (field, value) => {
    setPayouts((prev) => ({ ...prev, [field]: value }));
  };

  // 🔹 Submit form
  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: data.id,
      user_id: data.user_id,
      ...payouts,
    };

    postJsonData(
      ApiEndpoints.UPDATE_USER_CHARGES,
      payload,
      setRequest,
      (res) => {
        okSuccessToast(res?.data?.message);
        onSuccess();
      },
      (err) => apiErrorToast(err),
    );
  };

  if (!data) return null;

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{ width: 400 }} className="sm_modal">
        <Loader loading={request} />
        <ModalHeader title="Edit User Charges" handleClose={handleClose} />

        <Box
          component="form"
          id="editUserChargeForm"
          onSubmit={handleSubmit}
          sx={{ "& .MuiTextField-root": { m: 2 } }}
        >
          <Grid container>
            {/* USER ID */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  label="User ID"
                  value={data.user_id}
                  size="small"
                  disabled
                />
              </FormControl>
            </Grid>

            {/* PAYOUT FIELDS */}
            {["payout1", "payout2", "payout3", "payout4", "payout5"].map(
              (field, index) => (
                <Grid item xs={12} key={index}>
                  <FormControl fullWidth>
                    <TextField
                      label={`Payout ${index + 1}`}
                      size="small"
                      required
                      value={payouts[field]}
                      onChange={(e) =>
                        handlePayoutChange(field, e.target.value)
                      }
                    />
                  </FormControl>
                </Grid>
              ),
            )}
            {/* MIN AMOUNT */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  label="Min Amount"
                  size="small"
                  required
                  type="number"
                  value={payouts.min_amt}
                  onChange={(e) =>
                    handlePayoutChange("min_amt", e.target.value)
                  }
                />
              </FormControl>
            </Grid>

            {/* MAX AMOUNT */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  label="Max Amount"
                  size="small"
                  required
                  type="number"
                  value={payouts.max_amt}
                  onChange={(e) =>
                    handlePayoutChange("max_amt", e.target.value)
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mr: 2 }}>
          <ModalFooter
            form="editUserChargeForm"
            type="submit"
            btn="Update"
            disable={request}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default EditUserCharge;
